<template>
  <div class="page">
		<el-pagination :total="totalNumber" :small="small" :layout="layOut" :page-size="pageSize" :current-page.sync="currentPage" style="padding-top:20px;" @current-change="page_change"></el-pagination>
	</div>
</template>

<script>
	export default {
		name : "layer-page",
		props : {
			total : {type : [String,Number], default:0},
			small : {type : Boolean, default : false},
			pageSize : {type : Number, default:20},
			layOut : {type : String, default:'prev, pager, next, jumper, ->, total'},
      currentPage : {type : [String,Number], default : 1},
    },
		computed : {
			totalNumber (){
				return parseInt(this.total);
			}
		},
		methods : {
			page_change : function (e){
				console.log('1111111111111',e);
        this.currentPage = e;
        this.$emit('change',e);
			}
		},
	}
</script>

<style scoped>
.page{
  position: absolute;
  bottom: 20px;
  width: 95%;
}
</style>
